import React, { useEffect, useState } from 'react';
import axios from '../api/axiosConfig';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Pagination from '../components/Pagination';
import DetalleTramiteModal from '../components/DetalleTramiteModal';
import * as XLSX from 'xlsx';
import './Profiles.css';

const Eliminaciones = () => {
  const [tramitesEliminados, setTramitesEliminados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Modal Detalle
  const [selectedTramiteId, setSelectedTramiteId] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  // Paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  // Filtros
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchEliminados();
  }, []);

  const fetchEliminados = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/tramites/eliminados');
      // Ahora res.data tiene estructura: { data: [...], pagination: {...} }
      const tramitesArray = Array.isArray(res.data) ? res.data : (res.data.data || []);
      setTramitesEliminados(tramitesArray);
      setError('');
    } catch (err) {
      setError('Error al cargar la lista de eliminaciones.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = () => {
    if (filtered.length === 0) {
      alert('No hay datos para exportar.');
      return;
    }

    const exportData = filtered.map(t => ({
      'ID': t.id,
      'Placa Referencia': t.datos_adicionales?.placa_referencia || '—',
      'CUPL N°': t.datos_adicionales?.cupl_number || '—',
      'Propietario': t.datos_adicionales?.propietario || '—',
      'Tránsito': t.transito_name || '—',
      'Concesionario': t.concesionario_name || '—',
      'Creador': t.creador_name || '—',
      'Motivo Eliminación': t.deletion_reason || 'Sin motivo',
      'Fecha Eliminado': t.updated_at ? new Date(t.updated_at).toLocaleDateString('es-CO') : '—'
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Eliminados');
    XLSX.writeFile(workbook, `Tramites_Eliminados_${new Date().toLocaleDateString('es-CO')}.xlsx`);
  };

  const filtered = tramitesEliminados.filter(t => {
    if (searchTerm.trim() !== '') {
      const term = searchTerm.toLowerCase();
      const idMatch = t.id.toString().includes(term);
      const placaMatch = (t.datos_adicionales?.placa_referencia || '').toLowerCase().includes(term);
      const cuplMatch = (t.datos_adicionales?.cupl_number || '').toLowerCase().includes(term);
      const ownerMatch = (t.datos_adicionales?.propietario || '').toLowerCase().includes(term);
      if (!idMatch && !placaMatch && !cuplMatch && !ownerMatch) return false;
    }
    return true;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filtered.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <Navbar title="🗑️ Trámites Eliminados" />

        <div className="page-content">
          {error && <div className="error-banner">{error}</div>}

          <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="header-title">
              <h2>Historial de Eliminaciones</h2>
              <p className="subtitle">Listado de trámites que han sido eliminados por el tránsito</p>
            </div>
            <button 
              onClick={exportToExcel}
              style={{
                padding: '10px 16px',
                background: '#10b981',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '5px'
              }}
            >
              📥 Exportar a Excel
            </button>
          </div>

          <div className="dashboard-filters" style={{ 
            background: 'var(--card-bg)', 
            padding: '16px 24px', 
            borderRadius: '14px', 
            marginBottom: '20px',
            boxShadow: 'var(--card-shadow)',
            border: '1px solid var(--card-border)'
          }}>
            <div className="filter-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px', maxWidth: '300px' }}>
              <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--text-secondary)', textTransform: 'uppercase' }}>Buscar:</label>
              <input
                type="text"
                placeholder="ID, Placa, CUPL o Propietario..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                style={{ 
                  padding: '10px 14px', 
                  border: '1px solid var(--input-border)', 
                  borderRadius: '10px', 
                  background: 'var(--input-bg)', 
                  color: 'var(--text-primary)', 
                  fontSize: '13px', 
                  fontWeight: '500', 
                  outline: 'none',
                  width: '100%'
                }}
              />
            </div>
          </div>

          {loading ? (
            <p className="loading">Cargando trámites eliminados...</p>
          ) : (
            <div className="table-wrapper">
              <div className="table-responsive">
                <table className="users-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Placa Ref</th>
                      <th>CUPL N°</th>
                      <th>Propietario</th>
                      <th>Concesionario / Tránsito</th>
                      <th>Motivo de Eliminación</th>
                      <th>Fecha Eliminado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map(t => (
                      <tr key={t.id} style={{ background: '#fef2f2' }}>
                        <td data-label="ID"><strong>#{t.id}</strong></td>
                        <td data-label="Placa Ref">
                          {(t.plate || t.datos_adicionales?.placa_referencia) ? (
                            <span className="plate-badge-sm">{t.plate || t.datos_adicionales.placa_referencia}</span>
                          ) : '—'}
                        </td>
                        <td data-label="CUPL N°">
                          {t.datos_adicionales?.cupl_number ? (
                            <span style={{ 
                              fontFamily: 'monospace', 
                              fontWeight: 'bold', 
                              background: '#fef3c7', 
                              color: '#92400e', 
                              padding: '3px 8px', 
                              borderRadius: '6px', 
                              fontSize: '12px',
                              border: '1px solid #fde68a'
                            }}>
                              {t.datos_adicionales.cupl_number}
                            </span>
                          ) : '—'}
                        </td>
                        <td data-label="Propietario">{t.datos_adicionales?.propietario || 'N/A'}</td>
                        <td data-label="Concesionario / Tránsito">
                          {t.concesionario_name ? `🏢 ${t.concesionario_name}` : t.transito_name ? `🏢 ${t.transito_name}` : 'N/A'}
                        </td>
                        <td data-label="Motivo" style={{ maxWidth: '300px', whiteSpace: 'normal', color: '#b91c1c' }}>
                          {t.observaciones || t.deletion_reason || 'Sin motivo'}
                        </td>
                        <td data-label="Fecha Eliminado">{new Date(t.updated_at).toLocaleDateString()}</td>
                        <td data-label="Acciones">
                          <button 
                            onClick={() => {
                              setSelectedTramiteId(t.id);
                              setShowDetailModal(true);
                            }}
                            style={{
                              padding: '6px 14px',
                              background: '#2563eb',
                              color: 'white',
                              border: 'none',
                              borderRadius: '8px',
                              fontWeight: '600',
                              cursor: 'pointer',
                              fontSize: '12px',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '5px'
                            }}
                          >
                            👁️ Ver Detalle
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {filtered.length === 0 && (
                <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
                  No hay trámites eliminados.
                </div>
              )}

              <Pagination 
                currentPage={currentPage}
                totalItems={filtered.length}
                itemsPerPage={itemsPerPage}
                onPageChange={setCurrentPage}
                onItemsPerPageChange={(items) => {
                  setItemsPerPage(items);
                  setCurrentPage(1);
                }}
              />
            </div>
          )}
        </div>
      </div>

      <DetalleTramiteModal 
        isOpen={showDetailModal}
        tramiteId={selectedTramiteId}
        onClose={() => {
          setShowDetailModal(false);
          setSelectedTramiteId(null);
        }}
      />
    </div>
  );
};

export default Eliminaciones;
